import React from "react";
import Navbar from "../components/Navbar";
import PageTitle from "../components/PageTitle";
import SectionMySkills from "../components/SectionMySkills";
import SectionMyPartners from "../components/SectionMyPartners";
import Footer from "../components/Footer";
import Person from "../assets/img/person.png";
import { Icon } from "@iconify/react";

function About() {
	return (
		<>
			{/* Navbar */}
			<Navbar />

			{/* Page Title */}
			<PageTitle title="About" subtitle="About Me" />

			{/* Section 1 - About Me */}
			<section id="about-me">
				<div className="container pt-20 pb-32">
					<div className="mt-24 grid gap-10 lg:grid-cols-2 lg:gap-0">
						<div className="relative flex h-[400px] justify-center bg-[url(./assets/img/bg-about-me.jpg)] bg-cover lg:h-full lg:w-2/3">
							<div className="absolute bottom-0">
								<img src={Person} width={485} alt="" />
							</div>
						</div>
						<div>
							<div className="flex items-center gap-2 lg:gap-6">
								<h1 className="section-title__number">01</h1>
								<h3 className="section-title__text">About Me</h3>
							</div>
							<div className="my-6 border border-[#F2F3F4] lg:mt-0" />
							<h2 className="mb-4 font-anton text-2xl lg:text-3xl">
								I'm Professional Designer and Front-End Web Developer That Solve
								Your Problems
							</h2>
							<p className="mb-4 font-montserrat text-xs font-medium leading-8 text-grey lg:text-sm">
								Lorem ipsum dolor sit amet consectetur, adipisicing elit.
								Dolorem maxime deleniti, magnam id minima excepturi numquam
								quaerat odio reprehenderit blanditiis.
							</p>
							<p className="mb-8 font-montserrat text-xs font-medium leading-8 text-grey lg:text-sm">
								Lorem ipsum dolor sit amet consectetur adipisicing elit. Sint
								totam itaque maiores, ratione recusandae consectetur.
							</p>
							<div className="flex gap-16">
								<div className="flex items-center gap-3">
									<h1 className="font-anton text-[64px] tracking-wider text-main">
										8
									</h1>
									<h3 className="font-montserrat text-sm font-semibold tracking-tighter">
										Years
										<br />
										of Experience
									</h3>
								</div>
								<div className="flex items-center gap-3">
									<h1 className="font-anton text-[64px] tracking-wider text-main">
										25
									</h1>
									<h3 className="font-montserrat text-sm font-semibold tracking-tighter">
										Satisfied
										<br />
										Customers
									</h3>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>

			{/* Section 2 - My Skills */}
			<SectionMySkills />

			{/* Section 3 - My Experiences */}
			<section id="my-experiences">
				<div className="container">
					<div className="relative">
						<div className="absolute -z-10 grid h-full w-full grid-rows-1 lg:grid-cols-4 lg:divide-x lg:divide-light lg:border-x lg:border-light">
							<div />
							<div />
							<div />
							<div />
						</div>
						<div className="flex items-center justify-center gap-2 pt-28 lg:gap-6">
							<h1 className="section-title__number">03</h1>
							<h3 className="section-title__text">My Experiences</h3>
						</div>
						<div className="grid grid-cols-1 gap-8 pt-12 pb-28 sm:grid-cols-2 lg:grid-cols-4 lg:gap-0">
							<div>
								<Icon
									icon="logos:linkedin"
									className="text-[18px] opacity-40 grayscale"
								/>
								<div className="mt-6 flex items-center gap-4">
									<h3 className="font-anton text-[40px] text-main">01</h3>
									<div>
										<h5 className="font-montserrat font-bold tracking-tight">
											Lead Web Developer
										</h5>
										<h6 className="font-montserrat text-sm font-semibold tracking-tight text-main">
											2016-2020
										</h6>
									</div>
								</div>
								<p className="mt-3 w-4/5 font-montserrat text-sm leading-6 text-grey">
									Lorem, ipsum dolor sit amet consectetur adipisicing elit.
									Delectus quaerat architecto incidunt pariatur.
								</p>
							</div>
							<div className="mt-7 lg:mt-12">
								<Icon
									icon="logos:yahoo"
									className="text-[18px] opacity-40 grayscale"
								/>
								<div className="mt-6 flex items-center gap-4">
									<h3 className="font-anton text-[40px] text-main">02</h3>
									<div>
										<h5 className="font-montserrat font-bold tracking-tight">
											Lead Web Developer
										</h5>
										<h6 className="font-montserrat text-sm font-semibold tracking-tight text-main">
											2016-2020
										</h6>
									</div>
								</div>
								<p className="mt-3 w-4/5 font-montserrat text-sm leading-6 text-grey">
									Lorem, ipsum dolor sit amet consectetur adipisicing elit.
									Delectus quaerat architecto incidunt pariatur.
								</p>
							</div>
							<div className="mt-7 lg:mt-[90px]">
								<Icon
									icon="logos:zendesk"
									className="text-[18px] opacity-40 grayscale"
								/>
								<div className="mt-6 flex items-center gap-4">
									<h3 className="font-anton text-[40px] text-main">03</h3>
									<div>
										<h5 className="font-montserrat font-bold tracking-tight">
											Lead Web Developer
										</h5>
										<h6 className="font-montserrat text-sm font-semibold tracking-tight text-main">
											2016-2020
										</h6>
									</div>
								</div>
								<p className="mt-3 w-4/5 font-montserrat text-sm leading-6 text-grey">
									Lorem, ipsum dolor sit amet consectetur adipisicing elit.
									Delectus quaerat architecto incidunt pariatur.
								</p>
							</div>
							<div className="mt-7 lg:mt-[140px]">
								<Icon
									icon="logos:webflow"
									className="text-[18px] opacity-40 grayscale"
								/>
								<div className="mt-6 flex items-center gap-4">
									<h3 className="font-anton text-[40px] text-main">04</h3>
									<div>
										<h5 className="font-montserrat font-bold tracking-tight">
											Lead Web Developer
										</h5>
										<h6 className="font-montserrat text-sm font-semibold tracking-tight text-main">
											2016-2020
										</h6>
									</div>
								</div>
								<p className="mt-3 w-4/5 font-montserrat text-sm leading-6 text-grey">
									Lorem, ipsum dolor sit amet consectetur adipisicing elit.
									Delectus quaerat architecto incidunt pariatur.
								</p>
							</div>
						</div>
					</div>
				</div>
			</section>

			{/* Section 4 - My Partners */}
			<SectionMyPartners sectionNumber="04" />

			{/* Footer */}
			<Footer />
		</>
	);
}

export default About;
